<template>
  <div>
    <Navbar activeDirectory="admin" activePage="admin-create-work"></Navbar>

    <div class="container-fluid py-4">
      <!-- PAGE HEADER -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-between flex-wrap" style="gap:12px;">
            <div class="d-flex align-items-center">
              <div class="cw-header-icon mr-3">
                <i class="mdi mdi-clipboard-plus"></i>
              </div>
              <div class="text-left">
                <h3 class="mb-0 font-weight-bold text-dark">Nuovo Lavoro</h3>
                <p class="mb-0 text-muted small">Crea e assegna un nuovo intervento ad una squadra operativa</p>
              </div>
            </div>
            <router-link :to="{ name: 'admin-assigned-jobs' }" class="btn btn-light btn-sm rounded-pill px-4 font-weight-semibold border">
              <i class="mdi mdi-arrow-left mr-1"></i> Torna ai lavori
            </router-link>
          </div>
        </div>
      </div>

      <form @submit.prevent="createWork">
        <div class="row">

          <!-- ===== COL SX: Dettagli Intervento ===== -->
          <div class="col-12 col-lg-5 mb-4">
            <div class="cw-card h-100">
              <div class="cw-section-title">
                <span class="cw-step-num">1</span>Dettagli Intervento
              </div>

              <!-- Commessa -->
              <div class="form-group mb-4">
                <label class="cw-label">Commessa</label>
                <div class="cw-select-wrap">
                  <i class="mdi mdi-briefcase-outline cw-field-icon"></i>
                  <select v-model="lotto" class="cw-select" required @change="onCommessaChange">
                    <template v-if="commesse.length > 0">
                      <option v-for="c in commesse" :key="c.id" :value="String(c.id)">{{ c.nome }}</option>
                    </template>
                    <template v-else>
                      <option value="1">Commessa 1</option>
                      <option value="2">Commessa 2</option>
                    </template>
                  </select>
                  <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                </div>
              </div>

              <!-- Modulo -->
              <div class="form-group mb-4">
                <label class="cw-label">Modulo di competenza</label>
                <div class="cw-select-wrap">
                  <i class="mdi mdi-view-module-outline cw-field-icon"></i>
                  <select v-model="selectedModulo" class="cw-select" required @change="onModuloChange">
                    <option value="" disabled>Seleziona modulo...</option>
                    <option v-for="mod in myModules" :key="mod.id" :value="mod.codice">{{ mod.nome }}</option>
                  </select>
                  <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                </div>
                <!-- Module quick chips -->
                <div class="cw-chips mt-2" v-if="myModules.length > 0">
                  <span
                    v-for="mod in myModules" :key="'chip-'+mod.id"
                    class="cw-chip"
                    :class="{ 'cw-chip-active': selectedModulo === mod.codice }"
                    @click="selectedModulo = mod.codice; onModuloChange()"
                  >{{ mod.nome }}</span>
                </div>
              </div>

              <!-- Asset Coinvolto (Obbligatorio) -->
              <div class="form-group mb-4" v-if="selectedModulo && assetsForModule.length > 0">
                <label class="cw-label">Asset Coinvolto <span class="text-danger">*</span></label>
                <div class="cw-select-wrap">
                  <i class="mdi mdi-cogs cw-field-icon"></i>
                  <select v-model="form.fk_asset" class="cw-select" :required="assetsForModule.length > 0" @change="onAssetChange">
                    <option value="" disabled>Seleziona asset...</option>
                    <option v-for="asset in assetsForModule" :key="asset.id" :value="asset.id">
                      {{ asset.identificativo }} ({{ asset.asset_type_nome }})
                    </option>
                  </select>
                  <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                </div>
              </div>

              <!-- Tipologia -->
              <div class="form-group mb-4">
                <label class="cw-label">Tipologia Intervento <span class="text-danger">*</span></label>
                <div class="cw-select-wrap" :class="{ 'cw-disabled': !selectedModulo }">
                  <i class="mdi mdi-wrench-outline cw-field-icon"></i>
                  <select v-model="form.intervento" class="cw-select" required :disabled="!selectedModulo">
                    <option value="" disabled>{{ !selectedModulo ? 'Prima seleziona un modulo' : 'Seleziona tipologia...' }}</option>
                    <option v-for="item in interventi" :key="item.id" :value="item.codice">{{ item.nome }}</option>
                  </select>
                  <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                </div>
                <small class="text-muted mt-1 d-block" v-if="!selectedModulo">
                  <i class="mdi mdi-information-outline mr-1 text-primary"></i>Seleziona prima un modulo.
                </small>
              </div>

              <!-- Squadra -->
              <div class="form-group mb-0">
                <label class="cw-label">Squadra Incaricata <span class="text-danger">*</span></label>
                <div class="cw-select-wrap">
                  <i class="mdi mdi-account-multiple cw-field-icon"></i>
                  <select v-model="form.team_id" class="cw-select" required>
                    <option value="" disabled>Seleziona squadra...</option>
                    <option v-for="team in teams" :key="team.uid" :value="team.uid">{{ team.team }}</option>
                  </select>
                  <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- ===== COL DX: Luogo + Programmazione ===== -->
          <div class="col-12 col-lg-7">

            <!-- Luogo -->
            <div class="cw-card mb-4">
              <div class="cw-section-title">
                <span class="cw-step-num">2</span>Luogo dell'Intervento
              </div>

              <!-- Location mode toggle -->
              <div class="cw-location-tabs mb-4">
                <button type="button" class="cw-loc-tab" :class="{ active: locationMode === 'preset' }" @click="locationMode = 'preset'">
                  <i class="mdi mdi-format-list-bulleted"></i><span>Cantiere</span>
                </button>
                <button type="button" class="cw-loc-tab" :class="{ active: locationMode === 'free' }" @click="locationMode = 'free'">
                  <i class="mdi mdi-pencil-outline"></i><span>Indirizzo libero</span>
                </button>
                <button type="button" class="cw-loc-tab" :class="{ active: locationMode === 'map' }" @click="locationMode = 'map'">
                  <i class="mdi mdi-map-outline"></i><span>Seleziona su mappa</span>
                </button>
              </div>

              <!-- 1. Cantiere preimpostato -->
              <div v-if="locationMode === 'preset'">
                <label class="cw-label">Cerca cantiere <span class="text-danger">*</span></label>
                <div class="road-dropdown-wrapper">
                  <div class="cw-input-wrap">
                    <i class="mdi mdi-map-marker-outline cw-field-icon"></i>
                    <input
                      class="cw-input"
                      v-model="roadSearch"
                      @focus="showRoadOptions = true"
                      @blur="handleRoadBlur"
                      :placeholder="roads.length === 0 ? (loadingRoads ? 'Caricamento cantieri...' : 'Nessun cantiere trovato') : 'Cerca cantiere...'"
                      autocomplete="off"
                    />
                  </div>
                  <div class="road-dropdown-menu shadow-lg border-0" v-if="showRoadOptions && filteredRoads.length > 0">
                    <div
                      class="road-dropdown-item py-2 px-3"
                      @mousedown.prevent="selectRoad(road)"
                      v-for="road in filteredRoads"
                      :key="road.id">
                       {{ road.strada }}
                    </div>
                  </div>
                  <small class="text-danger mt-1 d-block" v-if="roadSearch && !form.strada">Seleziona un cantiere dalla lista</small>
                </div>
              </div>

              <!-- 2. Indirizzo libero -->
              <div v-if="locationMode === 'free'">
                <label class="cw-label">Indirizzo <span class="text-danger">*</span></label>
                <div class="road-dropdown-wrapper">
                  <div class="cw-input-wrap">
                    <i class="mdi mdi-text-search cw-field-icon"></i>
                    <input
                      type="text"
                      class="cw-input"
                      v-model="freeTextAddress"
                      @input="handleFreeAddressInput"
                      @focus="showFreeSuggestions = freeAddressSuggestions.length > 0"
                      @blur="handleFreeAddressBlur"
                      placeholder="Es. Via Roma, 12, Napoli"
                      autocomplete="off"
                      required
                    />
                    <span v-if="loadingFreeSuggestions" class="cw-input-spinner">
                      <span class="spinner-border spinner-border-sm text-primary"></span>
                    </span>
                  </div>
                  <div class="road-dropdown-menu shadow-lg border-0" v-if="showFreeSuggestions && freeAddressSuggestions.length > 0">
                    <div
                      class="road-dropdown-item py-2 px-3 d-flex align-items-center"
                      @mousedown.prevent="selectFreeSuggestion(suggestion)"
                      v-for="(suggestion, index) in freeAddressSuggestions"
                      :key="index">
                       <span class="text-truncate">{{ suggestion.display_name }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 3. Mappa -->
              <div v-show="locationMode === 'map'">
                <label class="cw-label">Clicca sulla mappa</label>
                <div class="rounded-lg border shadow-sm mb-3" style="height: 280px; position: relative; overflow: hidden; z-index: 1;">
                  <l-map
                    v-if="locationMode === 'map'"
                    style="height: 100%; width: 100%"
                    :zoom="zoom"
                    :center.sync="center"
                    @click="handleMapClick"
                    ref="workMap"
                  >
                    <l-tile-layer :url="currentMapUrl" :maxZoom="maxZoom"></l-tile-layer>
                    <l-marker v-if="tempMarker" :lat-lng="tempMarker">
                      <l-icon :icon-size="[32, 32]" :icon-anchor="[16, 32]" class-name="bg-transparent border-0">
                        <div class="map-marker-premium bg-danger shadow-md" style="font-size: 18px;">
                          <i class="mdi mdi-plus-circle h6 mb-0 text-white" style="line-height: 1;"></i>
                        </div>
                      </l-icon>
                    </l-marker>
                  </l-map>
                </div>
                <div v-if="tempMarker" class="cw-alert-info d-flex align-items-center mb-3">
                  <i class="mdi mdi-map-marker-check mr-2 text-primary h5 mb-0"></i>
                  <div>
                    <div class="font-weight-bold text-dark small">Punto selezionato</div>
                    <div class="text-muted" style="font-size:0.8rem;">{{ tempMarker.lat.toFixed(6) }}, {{ tempMarker.lng.toFixed(6) }}</div>
                  </div>
                </div>
                <div v-if="tempMarker" class="form-group mb-0">
                  <label class="cw-label">Descrizione posizione</label>
                  <div class="cw-input-wrap">
                    <i class="mdi mdi-road-variant cw-field-icon"></i>
                    <input type="text" class="cw-input" v-model="detectedAddress" placeholder="Nome della strada o descrizione..." required />
                  </div>
                  <small class="text-muted mt-1 d-block"><i class="mdi mdi-information-outline text-primary mr-1"></i>Puoi modificare se l'indirizzo non è corretto.</small>
                </div>
                <div v-else class="cw-alert-warning text-center">
                  <i class="mdi mdi-gesture-tap mr-1"></i> Clicca sulla mappa per impostare la posizione
                </div>
              </div>
            </div>

            <!-- Programmazione -->
            <div class="cw-card">
              <div class="cw-section-title">
                <span class="cw-step-num">3</span>Programmazione
                <small class="font-weight-normal text-muted ml-1" style="font-size:0.78rem;">(opzionale)</small>
              </div>
              <div class="row">
                <div class="col-sm-6 form-group mb-sm-0 mb-3">
                  <label class="cw-label">Data</label>
                  <div class="cw-input-wrap">
                    <i class="mdi mdi-calendar-outline cw-field-icon"></i>
                    <input type="date" class="cw-input" v-model="form.data_programmazione">
                  </div>
                </div>
                <div class="col-sm-6 form-group mb-0">
                  <label class="cw-label">Ora</label>
                  <div class="cw-input-wrap" :class="{ 'cw-disabled': !form.data_programmazione }">
                    <i class="mdi mdi-clock-outline cw-field-icon"></i>
                    <input type="time" class="cw-input" v-model="form.ora_programmazione" :disabled="!form.data_programmazione">
                  </div>
                  <small class="text-muted mt-1 d-block" v-if="!form.data_programmazione">Seleziona prima una data</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- FOOTER -->
        <div class="row mt-2">
          <div class="col-12">
            <div class="cw-footer d-flex align-items-center justify-content-between flex-wrap">
              <small class="text-muted">
                <i class="mdi mdi-asterisk text-danger" style="font-size:0.6rem; vertical-align:middle;"></i>
                Campi obbligatori
              </small>
              <div class="d-flex" style="gap: 12px;">
                <router-link :to="{ name: 'admin-assigned-jobs' }" class="btn btn-light rounded-pill px-4 font-weight-semibold border">
                  Annulla
                </router-link>
                <button type="submit" class="cw-btn-submit" :disabled="isSubmitDisabled">
                  <span class="spinner-border spinner-border-sm mr-2" v-if="loading"></span>
                  <i class="mdi mdi-check-circle-outline mr-1" v-else></i>
                  Crea Lavoro
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Navbar } from "@/components";
import { latLng } from "leaflet";

export default {
  components: {
    Navbar,
  },

  data() {
    return {
      tipologia: localStorage.getItem("tipologia"),
      lotto: localStorage.getItem("lotto") || "1",
      loading: false,
      loadingRoads: true,
      roadsError: false,
      teams: [],
      roads: [],
      assets: [],
      roadSearch: "",
      showRoadOptions: false,

      // Location mode fields
      locationMode: "preset", // 'preset', 'free', 'map'
      freeTextAddress: "",
      freeAddressSuggestions: [],
      showFreeSuggestions: false,
      loadingFreeSuggestions: false,
      freeAddressCoords: null,
      freeAddressTimeout: null,
      freeAddressRoadId: null,
      freeAddressRoadName: "",
      tempMarker: null,
      detectedAddress: "",
      closestRoadId: null,
      closestRoadName: "",
      zoom: 13,
      center: null,
      currentMapUrl: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      maxZoom: 19,

      myModules: [],
      selectedModulo: "",
      interventi: [],
      commesse: [],

      form: {
        intervento: "",
        strada: "",   // Stores the road ID
        fk_asset: "",
        team_id: "",
        data_programmazione: "",
        ora_programmazione: "",
      },
    };
  },

  computed: {
    assetsForModule() {
      if (!this.selectedModulo || this.assets.length === 0) return [];
      const mod = this.myModules.find(m => m.codice === this.selectedModulo);
      if (!mod) return [];
      return this.assets.filter(a => a.fk_module === mod.id);
    },
    filteredRoads() {
      if (!this.roadSearch) return this.roads;
      const regex = new RegExp(this.roadSearch, "i");
      return this.roads.filter((r) => r.strada.match(regex));
    },
    isSubmitDisabled() {
      if (this.loading) return true;
      if (!this.form.intervento || !this.form.team_id) return true;
      if (this.selectedModulo && this.assetsForModule.length > 0 && !this.form.fk_asset) return true;
      if (this.locationMode === 'preset') {
        return !this.form.strada;
      }
      if (this.locationMode === 'free') {
        return !this.freeTextAddress || !this.freeTextAddress.trim();
      }
      if (this.locationMode === 'map') {
        return !this.tempMarker || !this.detectedAddress || !this.detectedAddress.trim();
      }
      return true;
    },
  },

  watch: {
    locationMode(newMode) {
      if (newMode === 'map') {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs.workMap && this.$refs.workMap.mapObject) {
              this.$refs.workMap.mapObject.invalidateSize();
            }
          }, 200);
        });
      }
    },
    
  },

  async mounted() {
    if (this.tipologia !== "B" && this.tipologia !== "G") {
      this.$router.push({ name: "home" });
    } else {
      await this.fetchCommesse();
      this.fetchMyModules();
      this.fetchTeams();
      this.fetchRoads();
      this.fetchAssets();

      // Center the map dynamically based on GPS positions if available
      this.axios.get(`fleet-management/gps-positions/${this.lotto}`).then((response) => {
        if (response.data && response.data.features) {
          for (var i in response.data.features) {
            let geometry = response.data.features[i].geometry;
            if (geometry.coordinates[0] != 0 && geometry.coordinates[1] != 0) {
              this.center = latLng(geometry.coordinates[1], geometry.coordinates[0]);
              break;
            }
          }
        }
        if (!this.center) {
          this.center = latLng(40.8518, 14.2681);
        }
      }).catch(err => {
        console.error("Errore nel recupero posizioni GPS per centrare la mappa:", err);
        if (!this.center) {
          this.center = latLng(40.8518, 14.2681);
        }
      });

      // Pre-fill from query params if coming from calendar
      if (this.$route.query.date) {
        this.form.data_programmazione = this.$route.query.date;
      }
      if (this.$route.query.time) {
        this.form.ora_programmazione = this.$route.query.time;
      }
    }
  },

  methods: {
    fetchCommesse() {
      const companyId = localStorage.getItem("fk_company");
      if (!companyId) return Promise.resolve();
      return this.axios.get(`/companies/${companyId}/commesse`).then(res => {
        this.commesse = Array.isArray(res.data) ? res.data : [];
        if (this.commesse.length > 0) {
          const exists = this.commesse.some(c => String(c.id) === String(this.lotto));
          if (!exists) {
            this.lotto = String(this.commesse[0].id);
            localStorage.setItem("lotto", this.lotto);
          }
        }
      }).catch(err => {
        console.error("Errore recupero commesse:", err);
      });
    },

    fetchTeams() {
      this.axios.get(`teams/${this.lotto}`).then((response) => {
        this.teams = response.data;
      });
    },

    fetchMyModules() {
      this.axios.get('my-modules').then((response) => {
        this.myModules = Array.isArray(response.data) ? response.data : [];
      }).catch(err => {
        console.error("Errore recupero moduli:", err);
      });
    },

    fetchInterventiPerModulo() {
      if (!this.selectedModulo) {
        this.interventi = [];
        return;
      }
      let params = { modulo: this.selectedModulo };
      if (this.form.fk_asset) {
        const asset = this.assets.find(a => a.id === this.form.fk_asset);
        if (asset && asset.fk_asset_type) {
          params.asset_type_id = asset.fk_asset_type;
        }
      }
      this.axios.get('my-interventions', { params }).then((response) => {
        this.interventi = Array.isArray(response.data) ? response.data : [];
        if (this.form.intervento && !this.interventi.find(i => i.codice === this.form.intervento)) {
          this.form.intervento = "";
        }
      }).catch(err => {
        console.error("Errore recupero interventi modulo:", err);
      });
    },

    onCommessaChange() {
      localStorage.setItem("lotto", this.lotto);
      this.form.team_id = "";
      this.form.strada = "";
      this.form.fk_asset = "";
      this.roadSearch = "";
      this.fetchTeams();
      this.fetchRoads();
      this.fetchAssets();
    },

    onModuloChange() {
      this.form.intervento = "";
      this.form.fk_asset = "";
      this.fetchInterventiPerModulo();
    },

    onAssetChange() {
      this.fetchInterventiPerModulo();
    },

    fetchRoads() {
      this.loadingRoads = true;
      this.roadsError = false;
      this.axios.get(`sites?lotto=${this.lotto}`).then((response) => {
        this.roads = Array.isArray(response.data) ? response.data : [];
      }).catch((err) => {
        console.error("[fetchRoads] Errore:", err);
        this.roadsError = true;
      }).finally(() => {
        this.loadingRoads = false;
      });
    },

    fetchAssets() {
      this.axios.get(`/commesse/${this.lotto}/assets`)
        .then(res => {
          this.assets = (res.data && res.data.data) ? res.data.data : [];
        }).catch(err => {
          console.error("Errore recupero asset:", err);
        });
    },

    selectRoad(road) {
      this.form.strada = road.id;
      this.roadSearch = road.strada;
      this.showRoadOptions = false;
    },

    handleRoadBlur() {
      // Small delay to allow mousedown to fire first
      setTimeout(() => {
        this.showRoadOptions = false;
        // If user typed something but didn't select from list, clear the form value
        const match = this.roads.find(r => r.strada === this.roadSearch);
        if (!match) {
          this.form.strada = "";
        }
      }, 150);
    },

    handleFreeAddressInput() {
      // Reset coordinates since the text has changed
      this.freeAddressCoords = null;
      this.freeAddressRoadId = null;
      this.freeAddressRoadName = "";

      if (this.freeAddressTimeout) {
        clearTimeout(this.freeAddressTimeout);
      }

      if (!this.freeTextAddress || this.freeTextAddress.trim().length < 3) {
        this.freeAddressSuggestions = [];
        this.showFreeSuggestions = false;
        return;
      }

      this.freeAddressTimeout = setTimeout(() => {
        this.loadingFreeSuggestions = true;
        
        fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(this.freeTextAddress)}&limit=5&addressdetails=1&countrycodes=it`, {
          headers: {
            'Accept-Language': 'it'
          }
        })
          .then(res => {
            if (!res.ok) throw new Error("Search error");
            return res.json();
          })
          .then(data => {
            this.freeAddressSuggestions = data || [];
            this.showFreeSuggestions = true;
          })
          .catch(err => {
            console.error("Error fetching Nominatim suggestions:", err);
            this.freeAddressSuggestions = [];
          })
          .finally(() => {
            this.loadingFreeSuggestions = false;
          });
      }, 400);
    },

    handleFreeAddressBlur() {
      setTimeout(() => {
        this.showFreeSuggestions = false;
      }, 150);
    },

    selectFreeSuggestion(suggestion) {
      this.freeTextAddress = suggestion.display_name;
      this.freeAddressCoords = {
        lat: parseFloat(suggestion.lat),
        lng: parseFloat(suggestion.lon)
      };
      
      // Match with database roads if possible
      let osmRoadName = "";
      if (suggestion.address) {
        osmRoadName = suggestion.address.road || 
                      suggestion.address.pedestrian || 
                      suggestion.address.cycleway || 
                      suggestion.address.footway || 
                      suggestion.address.path || 
                      suggestion.address.square || 
                      suggestion.address.state_road || 
                      suggestion.address.suburb || 
                      "";
      }
      
      let matchedRoad = null;
      if (osmRoadName && this.roads.length > 0) {
        const normOsm = this.normalizeRoadName(osmRoadName);
        if (normOsm.length >= 3) {
          matchedRoad = this.roads.find(r => this.normalizeRoadName(r.strada) === normOsm);
          if (!matchedRoad) {
            matchedRoad = this.roads.find(r => {
              const normDb = this.normalizeRoadName(r.strada);
              return normDb.includes(normOsm) || normOsm.includes(normDb);
            });
          }
        }
      }

      if (matchedRoad) {
        this.freeAddressRoadId = matchedRoad.id;
        this.freeAddressRoadName = suggestion.display_name;
      } else {
        this.freeAddressRoadId = null;
        this.freeAddressRoadName = "";
      }
      
      this.showFreeSuggestions = false;
    },

    normalizeRoadName(name) {
      if (!name) return "";
      return name
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // remove accents
        .replace(/\b(via|viale|corso|piazza|strada|traversa|vicolo|largo|calata|salita|discesa|supportico|cupa|v\.le|p\.zza|c\.so|str\.)\b/gi, "") // remove common Italian prefixes
        .replace(/[^a-z0-9]/g, "") // remove non-alphanumeric characters
        .trim();
    },

    handleMapClick(e) {
      this.tempMarker = e.latlng;
      this.detectedAddress = "Ricerca indirizzo...";
      this.closestRoadId = null;
      this.closestRoadName = "";

      const lat = this.tempMarker.lat;
      const lng = this.tempMarker.lng;

      // 1. Fetch from backend nearby API
      const backendPromise = this.axios.get(`sites/nearby`, {
        params: {
          latitude: lat,
          longitude: lng,
          lotto: this.lotto
        }
      }).then(r => r.data || []).catch(err => {
        console.error("Error fetching nearby roads:", err);
        return [];
      });

      // 2. Fetch from Nominatim reverse geocoding
      const nominatimPromise = fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&addressdetails=1`, {
        headers: {
          'Accept-Language': 'it'
        }
      }).then(r => {
        if (!r.ok) throw new Error('Nominatim error');
        return r.json();
      }).catch(err => {
        console.error("Error fetching from Nominatim:", err);
        return null;
      });

      // Process both promises
      Promise.all([backendPromise, nominatimPromise]).then(([backendRoads, osmData]) => {
        let osmRoadName = "";
        let osmFullName = "";
        let city = "";
        
        if (osmData && osmData.address) {
          osmRoadName = osmData.address.road || 
                        osmData.address.pedestrian || 
                        osmData.address.cycleway || 
                        osmData.address.footway || 
                        osmData.address.path || 
                        osmData.address.square || 
                        osmData.address.state_road || 
                        osmData.address.suburb || 
                        "";
          osmFullName = osmData.display_name || "";
          city = osmData.address.city || osmData.address.town || osmData.address.village || osmData.address.municipality || "";
        }

        // Try to match Nominatim road name with our predefined lotto roads (this.roads)
        let matchedRoad = null;
        if (osmRoadName && this.roads.length > 0) {
          const normOsm = this.normalizeRoadName(osmRoadName);
          if (normOsm.length >= 3) {
            // First pass: try exact match after normalization
            matchedRoad = this.roads.find(r => this.normalizeRoadName(r.strada) === normOsm);
            
            // Second pass: try substring match if no exact match
            if (!matchedRoad) {
              matchedRoad = this.roads.find(r => {
                const normDb = this.normalizeRoadName(r.strada);
                return normDb.includes(normOsm) || normOsm.includes(normDb);
              });
            }
          }
        }

        // If we found a match in our database roads
        if (matchedRoad) {
          this.closestRoadId = matchedRoad.id;
          this.closestRoadName = matchedRoad.strada;
          this.detectedAddress = matchedRoad.strada;
        } 
        // If we didn't find a match in the database list, check Nominatim road name
        else if (osmRoadName) {
          // Check if Nominatim road name matches any of the backend nearby roads
          let backendMatch = null;
          if (backendRoads && backendRoads.length > 0) {
            const normOsm = this.normalizeRoadName(osmRoadName);
            if (normOsm.length >= 3) {
              backendMatch = backendRoads.find(r => {
                const name = r.nome || r.strada;
                const normDb = this.normalizeRoadName(name);
                return normDb === normOsm || normDb.includes(normOsm) || normOsm.includes(normDb);
              });
            }
          }

          if (backendMatch) {
            this.closestRoadId = backendMatch.id;
            this.closestRoadName = backendMatch.nome || backendMatch.strada;
            this.detectedAddress = this.closestRoadName;
          } else {
            // No database match found. Treat as custom text address!
            this.closestRoadId = null;
            this.closestRoadName = "";
            let formattedCustom = osmRoadName;
            if (city) {
              formattedCustom += `, ${city}`;
            }
            this.detectedAddress = formattedCustom || osmFullName || "Luogo selezionato su mappa";
          }
        } 
        // Fallback to backend closest road if Nominatim returned nothing
        else if (backendRoads && backendRoads.length > 0) {
          const closestRoad = backendRoads[0];
          this.closestRoadId = closestRoad.id;
          this.closestRoadName = closestRoad.nome || closestRoad.strada;
          this.detectedAddress = this.closestRoadName;
        } 
        // Total fallback
        else {
          this.closestRoadId = null;
          this.closestRoadName = "";
          this.detectedAddress = "Luogo selezionato su mappa";
        }
      });
    },

    createWork() {
      let stradaValue = "";
      if (this.locationMode === 'preset') {
        stradaValue = this.form.strada;
      } else if (this.locationMode === 'free') {
        if (this.freeAddressRoadId && this.freeTextAddress === this.freeAddressRoadName) {
          stradaValue = this.freeAddressRoadId;
        } else {
          stradaValue = this.freeTextAddress.trim();
        }
      } else if (this.locationMode === 'map') {
        // If the user did not modify the detected address, send the DB road ID.
        // Otherwise, send the custom text.
        if (this.closestRoadId && this.detectedAddress === this.closestRoadName) {
          stradaValue = this.closestRoadId;
        } else {
          stradaValue = this.detectedAddress.trim();
        }
      }

      if (!stradaValue) {
        this.$swal.fire({
          icon: "warning",
          title: "Attenzione",
          text: "Seleziona o scrivi una strada valida",
        });
        return;
      }

      this.loading = true;
      let formData = new FormData();
      formData.append("intervento", this.form.intervento);
      formData.append("strada", stradaValue);
      formData.append("team_id", this.form.team_id);
      if (this.form.fk_asset) {
        formData.append("fk_asset", this.form.fk_asset);
      }
      
      if (this.form.data_programmazione) {
        formData.append("data_programmazione", this.form.data_programmazione);
      }
      if (this.form.ora_programmazione) {
        formData.append("ora_programmazione", this.form.ora_programmazione);
      }

      if (this.locationMode === 'map' && this.tempMarker) {
        formData.append("latitudine", this.tempMarker.lat);
        formData.append("longitudine", this.tempMarker.lng);
      } else if (this.locationMode === 'free' && this.freeAddressCoords) {
        formData.append("latitudine", this.freeAddressCoords.lat);
        formData.append("longitudine", this.freeAddressCoords.lng);
      }

      this.axios
        .post(`dockyard/create`, formData)
        .then((response) => {
          this.loading = false;
          if (response.data["success"]) {
            this.$swal.fire({
              icon: "success",
              title: "Lavoro creato",
              text: "Il nuovo lavoro è stato creato con successo",
            }).then(() => {
              this.$router.push({ name: 'history', params: { scope: 'lavori' } });
            });
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Errore",
              text: response.data["message"] || response.data["error"] || "Errore durante la creazione del lavoro",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$swal.fire({
            icon: "error",
            title: "Errore",
            text: "Errore di connessione",
          });
          console.error("Error creating work:", error);
        });
    },
  },
};
</script>

<style scoped>
/* =========================================
   CREATE WORK — Premium UI
   ========================================= */

/* Header icon */
.cw-header-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(247, 147, 30, 0.35);
  flex-shrink: 0;
}
.cw-header-icon .mdi {
  color: #fff;
  font-size: 1.5rem;
}

/* Cards */
.cw-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  padding: 28px;
  border: 1px solid rgba(0,0,0,0.05);
}

/* Section title */
.cw-section-title {
  font-size: 0.82rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
  margin-bottom: 22px;
  display: flex;
  align-items: center;
}

.cw-step-num {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff;
  font-size: 0.7rem;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex-shrink: 0;
}

/* Labels */
.cw-label {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #94a3b8;
  margin-bottom: 8px;
  display: block;
}

/* Custom select */
.cw-select-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.cw-field-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
  font-size: 1rem;
  z-index: 2;
  pointer-events: none;
}
.cw-select {
  width: 100%;
  height: 46px;
  padding: 0 38px 0 36px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  font-size: 0.92rem;
  font-weight: 500;
  color: #1e293b;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
}
.cw-select:focus {
  border-color: #F7931E;
  box-shadow: 0 0 0 3px rgba(247,147,30,0.12);
  background: #fff;
}
.cw-select-arrow {
  position: absolute;
  right: 14px;
  color: #94a3b8;
  font-size: 1rem;
  pointer-events: none;
}
.cw-disabled {
  opacity: 0.5;
  pointer-events: none;
}

/* Custom input */
.cw-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.cw-input {
  width: 100%;
  height: 46px;
  padding: 0 14px 0 36px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  font-size: 0.92rem;
  font-weight: 500;
  color: #1e293b;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
}
.cw-input:focus {
  border-color: #F7931E;
  box-shadow: 0 0 0 3px rgba(247,147,30,0.12);
  background: #fff;
}
.cw-input-spinner {
  position: absolute;
  right: 14px;
  z-index: 3;
}

/* Module chips */
.cw-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.cw-chip {
  display: inline-block;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  background: #f1f5f9;
  color: #64748b;
  border: 1.5px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.15s;
  user-select: none;
}
.cw-chip:hover {
  background: #FEF1E0;
  border-color: #F5B871;
  color: #E07B00;
}
.cw-chip-active {
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff;
  border-color: transparent;
}

/* Location tabs */
.cw-location-tabs {
  display: flex;
  background: #f1f5f9;
  border-radius: 12px;
  padding: 4px;
  gap: 2px;
}
.cw-loc-tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 10px 6px;
  border: none;
  border-radius: 9px;
  background: transparent;
  color: #94a3b8;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  cursor: pointer;
  transition: all 0.2s;
}
.cw-loc-tab .mdi {
  font-size: 1.15rem;
}
.cw-loc-tab:hover {
  background: rgba(255,255,255,0.7);
  color: #F7931E;
}
.cw-loc-tab.active {
  background: #fff;
  color: #E07B00;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

/* Alerts */
.cw-alert-info {
  background: #FEF1E0;
  border-radius: 10px;
  padding: 12px 16px;
  border: 1px solid #FBD9AE;
}
.cw-alert-warning {
  background: #fffbeb;
  border-radius: 10px;
  padding: 12px 16px;
  border: 1px solid #fde68a;
  color: #92400e;
  font-size: 0.85rem;
  font-weight: 500;
}

/* Footer */
.cw-footer {
  background: #fff;
  border-radius: 14px;
  padding: 18px 24px;
  border: 1px solid rgba(0,0,0,0.05);
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* Submit button */
.cw-btn-submit {
  display: inline-flex;
  align-items: center;
  padding: 10px 28px;
  border: none;
  border-radius: 30px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(247,147,30,0.35);
  transition: all 0.2s;
}
.cw-btn-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #E07B00, #C96A00);
  box-shadow: 0 6px 18px rgba(247,147,30,0.45);
  transform: translateY(-1px);
}
.cw-btn-submit:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
}

/* Dropdown */
.road-dropdown-wrapper {
  position: relative;
}
.road-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-top: none;
  border-radius: 0 0 10px 10px;
  max-height: 220px;
  overflow-y: auto;
  z-index: 1050;
  box-shadow: 0 8px 24px rgba(0,0,0,0.1);
}
.road-dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #334155;
}
.road-dropdown-item:hover {
  background-color: #FEF1E0;
  color: #C96A00;
}
</style>
